import { useContext, useEffect, useState } from 'react'
import { Button, Flex, Flexed, Input, Label, MainWrap, Selectbox } from '../../utilities/Shared'
import axios from 'axios';
import { CiCircleRemove, CiCircleMinus } from "react-icons/ci";
import { IoAddCircleOutline } from "react-icons/io5";
import { useParams } from 'react-router-dom';
import Moment from 'react-moment';
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';
import UserContext from '../../Context/UserContext';
import { getcustomerfromname, getemployeefromempid } from '../../utilities/Convertions';
import PressSheetEstimator from './PressForm';

const Estimater = () => {

const { quote } = useParams();

const { employees, customers, salesreps, userInfo,papers } = useContext(UserContext);

const [quoteInfo,setQuoteInfo] = useState(null);
const [loading,setLoading] = useState(true);
const [formReady,setFormReady] = useState(false);
const [error,setError] = useState(false);

const [customerSearch,setCustomerSearch] = useState('');
const [contactSearch,setContactSearch] = useState('');

const [quantities,setQuantities] = useState([]);
const [showAddQuantityInput,setShowAddQuantityInput] = useState(false);
const [newQuantity,setNewQuantity] = useState('');


/* ---------------- RFQ LOAD ---------------- */
useEffect(()=>{

// WAIT for context to load
if(!customers?.length || !employees?.length || !salesreps?.length) return;

const loadRFQ = async () =>{

setLoading(true);

try{

const internalRes = await axios.post(
"http://localhost:5001/rfq/getrfq",
{quote},
{headers:{'Content-Type':'application/json'}}
);

if(internalRes.data?.length){
setQuoteInfo(internalRes.data[0]);
setLoading(false);
return;
}

const legacyRes = await axios.post(
"https://highgroundsoftware.com/dash/dashboard/php/getrfqquote.php",
{quote:quote.replace(/\D/g,'').trim()},
{headers:{'Content-Type':'application/json'}}
);

if(legacyRes.data){
  console.log(legacyRes.data)
await formatToNewDataStructure(legacyRes.data);
}else{
setError(true);
}

}catch(err){
console.error(err);
setError(true);
}

setLoading(false);

}

if(quote) loadRFQ();

},[quote, customers, employees, salesreps]);

const handleCustomerChange = (value) => {
  setCustomerSearch(value);

  // Find the selected customer
  const selectedCustomer = customers.find(c => c.name === value) || null;

  let resolvedContact = null;

  if (selectedCustomer?.contacts?.length) {
    // 1️⃣ If old contact exists in previous quoteInfo, try to match
    if (quoteInfo?.contact?.old) {
      resolvedContact = selectedCustomer.contacts.find(
        c => String(c.old) === String(quoteInfo?.contact.old)
      );
    }

    // 2️⃣ If not found, use main contact
    if (!resolvedContact && selectedCustomer.maincontact) {
      resolvedContact = selectedCustomer.contacts.find(
        c => String(c.contactid) === String(selectedCustomer.maincontact)
      );
    }
  }

  // Update quoteInfo with new customer, contacts, and resolved contact
  setQuoteInfo(prev => ({
    ...prev,
    customer: selectedCustomer,
    contacts: selectedCustomer?.contacts || [],
    contact: resolvedContact || null
  }));

  // Update the input display
  setContactSearch(resolvedContact?.name || '');
};

/* ---------------- LEGACY FORMAT ---------------- */

const formatToNewDataStructure = async (quotestuff)=>{

const customerMatch = await  getcustomerfromname(quotestuff.customer,customers);
const salesrepMatch = getemployeefromempid(quotestuff.salesrep,employees);

const displayCustomer = customerMatch || {name:quotestuff.customer};

const displaySalesrep = salesrepMatch || {
empId:quotestuff.salesrep,
firstName:"Legacy",
lastName:quotestuff.salesrep
};





let resolvedContact = null;

if (customerMatch?.contacts?.length) {

  // 1️⃣ Try legacy contact match
  if (quotestuff.contact) {
    resolvedContact = customerMatch.contacts.find(
      c => String(c.old) === String(quotestuff.contact)
    );
  }

  // 2️⃣ If not found, use customer's main contact
  if (!resolvedContact && customerMatch?.maincontact) {
    resolvedContact = customerMatch.contacts.find(
      c => String(c.contactid) === String(customerMatch.maincontact)
    );
  }

}


const Data = {
  entered: quotestuff.entered ? new Date(quotestuff.entered) : null,
  customer: displayCustomer,
  contacts: customerMatch?.contacts || [],
  contact: resolvedContact || null,

  salesrep: displaySalesrep,

  customerid: quotestuff.customerid || "",

  prevjob: quotestuff.prevjob || "",
  prevquote: quotestuff.prevquote || "",   // note: your sample uses prevQuote

  quote: quotestuff.quote || "",

  pname: quotestuff.pname || "",
  priority: quotestuff.priority || "Standard",

  pagecount: quotestuff.pagecount || "",
  coverstyle: quotestuff.coverstyle || "",
  versions: quotestuff.versions || "",
  versionnotes: quotestuff.versionnotes || "",

  pflatw: quotestuff.pflatw || "",
  pflatl: quotestuff.pflatl || "",
  pfoldw: quotestuff.pfoldw || "",
  pfoldl: quotestuff.pfoldl || "",

  quantity: quotestuff.quantity || "",

  bindstyle: quotestuff.bindstyle || "",
  presscheck: quotestuff.presscheck || "No",

  projectstyle: quotestuff.projectstyle || "",

  old: quotestuff.contact || "",

  // ────────────────────────────────────────────────
  // NEW: Build forms array from comp1–comp10
  // ────────────────────────────────────────────────
  forms: (() => {
    const formsArray = [];

    for (let i = 1; i <= 10; i++) {
      const key = `comp${i}`;
      const value = quotestuff[key];

      // Skip if missing, null, undefined, or empty string
      if (!value || typeof value !== 'string' || value.trim() === '') {
        continue;
      }

      const parts = value.split(':').map(part => part.trim());


        const paperObj = papers?.find(
        p => p.stockid === parts[2] || null);



console.log(paperObj)
      const form = {
        id:Date.now(),                           // or use Date.now() + i if needed
        componentKey: key,               // "comp1", "comp2", etc.
        raw: value,                      // keep original string for debugging

        componentName: parts[0] || "",
        paper:paperObj ,
        basisWeight: parts[2] || "",
        mWeight: parts[3] || "",         // guessing names — adjust!
        flatWidth: parts[4] || "",
        flatLength: parts[5] || "",
        foldWidth: parts[6] || "",
        foldLength: parts[7] || "",
        finks: parts[8].toUpperCase() || "",
        binks: parts[9].toUpperCase() || "",
        versions:1,
        pagecount:quoteInfo?.pagecount,
        forms:1,
        fpercent:.07,
        bpercent:.07,
        fpasses:1,
        bpasses:1,
        fplates:(parts[8]).split(',').filter(Boolean).length || "",   
        bplates:(parts[9]).split(',').filter(Boolean).length || "", 
        press:null,
        // Add more fields here as needed:
        // aqueous: parts[10] || "",
        // varnish: parts[11] || "",
        // coatingType: parts[12] || "",
        // ...
        pressNotes: parts[20] || "",     // "Best Press" was around here
        // quantityPerComp: parts[25] || "",  // last "2" in your example
      };

      formsArray.push(form);
    }

    return formsArray;
  })(),
};
setQuoteInfo(Data);
if (Data.contact) {
  setContactSearch(Data.contact.name);
} else {
  setContactSearch("");
}

};

/* ---------------- FORM READY ---------------- */

useEffect(()=>{

if(
quoteInfo &&
customers?.length &&
employees?.length &&
salesreps?.length
){
setFormReady(true);
}

},[quoteInfo,customers,employees,salesreps]);


/* ---------------- CONTACT AUTO SELECT ---------------- */

useEffect(()=>{

if(!quoteInfo?.contacts?.length) return;

let contactId = null;

if(quoteInfo?.old){
contactId = quoteInfo?.old;
}

if(!contactId && quoteInfo?.customer?.maincontact){
contactId = quoteInfo?.customer.maincontact;
}

if(!contactId) return;

const foundContact = quoteInfo?.contacts.find(
c => String(c.contactid || c.id || c.old) === String(contactId)
);

if(foundContact){

setContactSearch(foundContact.name);

setQuoteInfo(prev=>({
...prev,
contact:foundContact
}));

}

},[quoteInfo?.customer]);


/* ---------------- CUSTOMER SEARCH ---------------- */

useEffect(()=>{

if(quoteInfo?.customer?.name){
setCustomerSearch(quoteInfo?.customer.name);
}

},[quoteInfo?.customer]);


/* ---------------- QUANTITY SYSTEM ---------------- */

useEffect(()=>{

if(quoteInfo?.quantity){

const qtyArray = Array.isArray(quoteInfo?.quantity)
? quoteInfo?.quantity
: quoteInfo?.quantity.split(',').map(q=>Number(q.trim()));

setQuantities(qtyArray);

}

},[quoteInfo?.quantity]);

useEffect(()=>{

if(quoteInfo){
setQuoteInfo(prev=>({...prev,quantity:quantities.join(',')}));
}

},[quantities]);

const handleAddQuantity = ()=>{

const num = Number(newQuantity.trim());

if(!isNaN(num) && num>0){

setQuantities(prev=>[...new Set([...prev,num])].sort((a,b)=>a-b));

setNewQuantity('');
setShowAddQuantityInput(false);

}

};

const handleRemoveQuantity = (qty)=>{
setQuantities(prev=>prev.filter(q=>q!==qty));
};


/* ---------------- SALES REP ---------------- */

const changerep = (e)=>{

const empId = e.target.value;

const employee = employees.find(emp=>emp.empId === empId);

setQuoteInfo(prev=>({...prev,salesrep:employee}));

};


/* ---------------- GUARDS ---------------- */

console.log(loading)
console.log(quoteInfo)
/* ---------------- UI ---------------- */
if(!quoteInfo?.quote && !loading){
return <MainWrap><div style={{fontSize:'2rem',textAlign:'center',color:'rgb(255,0,0,.7)',marginTop:'40px'}}>No request can be found for RFQ Number {quote}</div></MainWrap>
}
return(

<MainWrap style={{fontSize:"calc(1.2rem + .2vw)",color:"#418DA7"}}>

{/* HEADER */}

<Flexed padding="20px" gap="10px" borderBottom="1px solid">

<Flex flex="1.5" >
Quote: <b style={{fontSize:"clamp(2rem, 2rem, 3rem)"}}>{quote}</b>
</Flex>

<Flex flex="2">
Date Entered:
{quoteInfo?.entered &&
<Moment format="MM/DD/YYYY" style={{fontSize:"clamp(2rem, 2rem, 3rem)"}}>
  {quoteInfo?.entered}
</Moment>}
</Flex>

<Flex textAlign="right"><Button>Delete</Button></Flex>
<Flex textAlign="right"><Button>Copy</Button></Flex>

</Flexed>


{/* CUSTOMER ROW */}

<Flexed gap="10px" padding="15px 10px">

<Flex flex="2">
  <Label>Customer</Label>

  <Input
    list="customers"
    value={customerSearch}
    onChange={(e) => handleCustomerChange(e.target.value)}
  />

  <datalist id="customers">
    {customers.map((c, i) => (
      <option key={i} value={c.name} />
    ))}
  </datalist>
</Flex>

<Flex>
  Contact
  <Input
    list="contacts"
    value={contactSearch}
    onChange={(e) => {
      const value = e.target.value;
      setContactSearch(value);

      // Only assign a valid contact object if a contact matches
      const selected = quoteInfo?.contacts?.find(c => c.name === value) || null;

      setQuoteInfo(prev => ({
        ...prev,
        contact: selected
      }));
    }}
    placeholder="Type or select contact..."
    disabled={!quoteInfo?.customer}
  />

  <datalist id="contacts">
    {quoteInfo?.contacts?.map((c, i) => (
      <option key={i} value={c.name} />
    ))}
  </datalist>
</Flex>

<Flex>

Sales Rep

<Selectbox
value={quoteInfo?.salesrep?.empId || ""}
onChange={changerep}
>

<option value="">Select</option>

{salesreps.map((s)=>(
<option key={s.empId} value={s.empId}>
{s.firstName} {s.lastName}
</option>
))}

</Selectbox>

</Flex>

</Flexed>


{/* PREV JOB ROW */}

<Flexed gap="10px" padding="5px 10px 15px 10px">

<Flex flex="2">
Prev Job #
<Input
value={quoteInfo?.prevjob}
onChange={(e)=>setQuoteInfo(prev=>({...prev,prevjob:e.target.value}))}
/>
</Flex>

<Flex>
Prev Quote #
<Input
value={quoteInfo?.prevquote}
onChange={(e)=>setQuoteInfo(prev=>({...prev,prevquote:e.target.value}))}
/>
</Flex>

<Flex>
Estimator
<Input
value={`${userInfo.firstName} ${userInfo.lastName}`}
readOnly
/>
</Flex>

<Flex>
Priority
<Selectbox
value={quoteInfo?.priority}
onChange={(e)=>setQuoteInfo(prev=>({...prev,priority:e.target.value}))}
>
<option value="Standard">Standard</option>
<option value="ASAP">ASAP</option>
<option value="Hot">Hot</option>
</Selectbox>
</Flex>

</Flexed>


{/* PROJECT ROW */}

<Flexed gap="10px" padding="15px 10px">

<Flex flex="2">
Project
<Input
value={quoteInfo?.pname}
onChange={(e)=>setQuoteInfo(prev=>({...prev,pname:e.target.value}))}
/>
</Flex>

<Flex>
Project Style
<Input
value={quoteInfo?.projectstyle}
onChange={(e)=>setQuoteInfo(prev=>({...prev,projectstyle:e.target.value}))}
/>
</Flex>

<Flex>
Press Check
<Selectbox
value={quoteInfo?.presscheck}
onChange={(e)=>setQuoteInfo(prev=>({...prev,presscheck:e.target.value}))}
>
<option>No</option>
<option>Yes</option>
</Selectbox>
</Flex>

</Flexed>


{/* SIZE ROW */}

<Flexed gap="10px" padding="15px 10px">

<Flex>Flat W<Input value={quoteInfo?.pflatw}/></Flex>
<Flex>Flat L<Input value={quoteInfo?.pflatl}/></Flex>
<Flex>Finish W<Input value={quoteInfo?.pfoldw}/></Flex>
<Flex>Finish L<Input value={quoteInfo?.pfoldl}/></Flex>
<Flex>Pages<Input value={quoteInfo?.pagecount}/></Flex>
<Flex>Versions<Input value={quoteInfo?.versions}/></Flex>
<Flex>Cover Style<Input value={quoteInfo?.coverstyle}/></Flex>

</Flexed>


{/* QUANTITY SECTION */}

{/* QUANTITY SECTION */}

<Flexed 
  padding="15px 10px" 
  gap="16px" 
marginBottom='25px'
>

  {/* Add quantity row – always visible, right-aligned input */}
  <Flex 
  flex='.5'
width='200px'
  >
    <div style={{ 
      fontWeight: 'bold', 
      color: '#418DA7',
marginBottom:'10px'
    }}>
      Add Quantity
    </div>

    <Input
      type="number"
      placeholder=""
      value={newQuantity}
      padding='0'
      onChange={(e) => setNewQuantity(e.target.value)}
      onKeyDown={(e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
          handleAddQuantity();
        }
      }}
      style={{
        width: '140px',
        maxWidth: '140px',
        textAlign: 'left'
      }}
    />
    
  </Flex>
  <Flex 
    flex='1'
    display='flex'
    flexwrap="wrap"
    style={{ 
      width: '100%',
      justifyContent: 'flex-start', 
      marginTop:'27px'  
    }}
  >
    {quantities.map((q, i) => (
      <div
        key={i}
        style={{
          width: '150px',
          minWidth: '150px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-end',
          gap: '8px',
          background: '#f0f8ff',
          border: '1px solid #0f62c8',
          borderRadius: '6px',
          padding: '6px 10px',
          fontWeight: '800',
          marginRight:'26px',
        }}
      >
        <span style={{ 
          flex: 1,
          textAlign: 'center',
          fontFamily: 'monospace',
          fontSize: '1.3em',

        }}>
          {q.toLocaleString()}
        </span>
        <CiCircleRemove 
          onClick={() => handleRemoveQuantity(q)}
          style={{ 
            cursor: 'pointer', 
            color: '#e63946',
            fontSize: '1.8rem',
            flexShrink: 0
          }}
        />
      </div>
    ))}
  </Flex>

</Flexed>
{/* <Flexed padding="15px 10px" gap="12px">

<Flex>

{showAddQuantityInput ?

<CiCircleMinus onClick={()=>setShowAddQuantityInput(false)}/>

:

<IoAddCircleOutline onClick={()=>setShowAddQuantityInput(true)}/>

}

Quantities

</Flex>

<Flex gap="10px">

{quantities.map((q,i)=>(
<Flex key={i}>
<CiCircleRemove onClick={()=>handleRemoveQuantity(q)}/>
<Input readOnly value={q}/>
</Flex>
))}

</Flex>

</Flexed> */}


{/* TABS */}

<Tabs>

<TabList>
<Tab>Press</Tab>
<Tab>Components</Tab>
<Tab>Bindery</Tab>
<Tab>Mailing</Tab>
</TabList>

<TabPanel><PressSheetEstimator quoteInfo={quoteInfo} setQuoteInfo={setQuoteInfo} papers={papers}/></TabPanel>
<TabPanel>Components</TabPanel>
<TabPanel>Bindery</TabPanel>
<TabPanel>Mailing</TabPanel>

</Tabs>


</MainWrap>

)

}

export default Estimater;